import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ImageDropzone, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import { Button, Label } from 'reactstrap'
import fastSellProductEntrupyFormSchema from './fast-sell_product-entrupy-form-schema'


const propTypes = {
  fastSellProduct: PropTypes.shape({
    entrupy_image: PropTypes.object
  }),
  onClickSubmit : PropTypes.func,
  disabled      : PropTypes.bool
}

const defaultProps = {
  seller        : {},
  onClickSubmit : () => { },
  disabled      : false
}

/**
 *
 * @param {object} fastSellProduct - fast sell product object from backend with all associations
 * @param {function} onClickSubmit  - function to handle submission of this form
 * @param {boolean} disabled  - boolean to disable update button
 * @returns
 */
const FastSellProductEntrupyForm = ({
  fastSellProduct,
  onClickSubmit,
  disabled
}) => {

  const [ entrupyImage, setEntrupyImage ] = useState()

  // Set Default Entrupy Image
  useEffect(() => {
    const entrupyImage = fastSellProduct?.entrupy_image
    if (fastSellProduct?.entrupy_image){
      setEntrupyImage(entrupyImage?.s3_url)
    }
  }, [ fastSellProduct ])
  /**
   * Resizes images to max width or height of 1280 pixels
   *
   * @param {Array<File>} files - dropzone returns array of files even if isMulti=false
   * @param {object} arrayHelpers - Formik's FieldArray helpers
   */
  const handleDropImage = async (files, formik) => {
    setEntrupyImage(URL.createObjectURL(files[0]))
    formik.setFieldValue('entrupy_image', files)
  }

  const handleClickRemoveImage = (formik) => {
    setEntrupyImage(undefined)
    formik.setFieldValue('entrupy_image',[])
  }

  const handleClickRemove = (formik, fieldName) => {
    formik.setFieldValue(fieldName, '')
  }

  return (
    <Formik
      initialValues={{ entrupy_image: [] }}
      enableReinitialize={ true }
      validationSchema={ fastSellProductEntrupyFormSchema }
      onSubmit={ onClickSubmit }
    >
      {
        (formik) => (
          <Form>
            <Label
              for={ 'entrupy_image' }
              className='text-capitalize form-control-label font-weight-bold'
            >
              { 'gambar entrupy' }
            </Label>
            {
              entrupyImage
                ? (
                  <div className='mb-3 align-items-start'>
                    <img src={ entrupyImage } alt="Identity Proof Image" width={ '200px' } />
                    <Button
                      color={ 'danger' }
                      className='rounded ml-3'
                      onClick={ () => handleClickRemoveImage(formik) }
                    >
                      <i className='fas fa-trash'/>
                    </Button>
                  </div>
                )
                : (
                  <div
                    className='mb-3'
                    style={{
                      width         : '20rem',
                      border        : '1px dashed grey',
                      borderRadius  : '10px',
                      boxSizing     : 'border-box',
                      display       : 'flex',
                      flexDirection : 'column',
                      textAlign     : 'center',
                      paddingTop    : '15px'
                    }}
                  >
                    <ImageDropzone
                      name={ 'entrupy_image' }
                      placeholderImg={ '/img/image-dropzone-placeholder.svg' }
                      onDrop={ (files) => handleDropImage(files, formik) }
                      onClickRemove={ () => handleClickRemove(formik, 'entrupy_image') }
                    />
                    <small
                      style={{ fontSize: '0.67rem' }}
                      className='d-block text-center text-capitalize font-weight-light text-gray'
                    >
                      { 'gambar entrupy' }
                    </small>
                  </div>
                )
            }
            <LoaderButton
              className={ 'rounded float-right' }
              type={ 'submit' }
              color={ 'primary' }
              disabled={ disabled }
              text={ 'Update Entrupy' }
            />
          </Form>
        )
      }
    </Formik>
  )
}

FastSellProductEntrupyForm.propTypes    = propTypes
FastSellProductEntrupyForm.defaultProps = defaultProps

export default FastSellProductEntrupyForm
